// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";

// import firebase from "firebase/compat/app";
// import firebaseui from "firebaseui/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBasCdmPmTv9UuYyfvFH2ZLOViS5Ul3Nq8",
//   authDomain: "Local Bonsai-9ccf8.firebaseapp.com",
//   projectId: "Local Bonsai-9ccf8",
//   storageBucket: "Local Bonsai-9ccf8.appspot.com",
//   messagingSenderId: "22130986770",
//   appId: "1:22130986770:web:3ba6489a5a85e98ee5adcb",
// };

// How to find: go to project-sttings/general and scroll down to "Your apps" click one of the buttons to add app

// Initialize Firebase
// export const app = initializeApp(firebaseConfig);
// export const analytics = getAnalytics(app);

// Import the functions you need from the SDKs you need
import {
  initializeApp
} from "firebase/app";
import {
  getAnalytics
} from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBCxAxNJKtP2GDcjTJCV-1_YSTA_-9VqUs",
  authDomain: "local-bonsai.firebaseapp.com",
  projectId: "local-bonsai",
  storageBucket: "local-bonsai.appspot.com",
  messagingSenderId: "995414592592",
  appId: "1:995414592592:web:f37bd6050f7a16582a9555",
  measurementId: "G-4V9XSM6B8Y"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

// Create a Firebase reference where GeoFire will store its information
// var firebaseRef = ref(getDatabase(app));

// // Create a GeoFire index
// export var geoFire = new GeoFire(firebaseRef);

// export const geofireRef = new GeoFire(app.database().ref('https://local-bonsai.firebaseio.com/geofire/'));